import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../lib/firebase";

const Team = () => {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    getDocs(collection(db, "team")).then((snap) => {
      setTeam(snap.docs.map(d => d.data()));
    });
  }, []);

  return (
    <div className="max-w-6xl mx-auto p-10">
      <h1 className="text-4xl font-bold mb-10 text-center">Our Team</h1>

      <div className="grid md:grid-cols-3 gap-8">
        {team.map((m, i) => (
          <div key={i} className="shadow-lg p-6 rounded text-center">
            <img
              src={m.image}
              className="w-28 h-28 rounded-full mx-auto mb-4 object-cover"
            />
            <h3 className="font-semibold">{m.name}</h3>
            <p className="text-gray-600">{m.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
